import { Link } from "react-router-dom";
import { PRIORITY_STYLES } from "@/lib/api";
import { Th } from "@/components/common";
import { Badge } from "@/components/ui/badge";
import { MessageCircle, Phone, User, Hash, AlertTriangle } from "lucide-react";

export function OrdersTable({ orders, styleOf, emptyText = "Nenhuma OS encontrada.", readOnly = false }) {
  const OrderLink = ({ to, className, children }) => (
    readOnly ? <span className={className}>{children}</span> : <Link to={to} className={className}>{children}</Link>
  );
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-slate-50 dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800">
          <tr><Th>OS</Th><Th>Cliente</Th><Th>Assunto</Th><Th>Fila / Tipo</Th><Th>Responsável</Th><Th>Prior.</Th><Th>Status</Th><Th>Canal</Th><Th right>Criada</Th></tr>
        </thead>
        <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
          {orders.length === 0 && <tr><td colSpan={9} className="text-center py-10 text-sm text-slate-500">{emptyText}</td></tr>}
          {orders.map((o) => (
            <tr key={o.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors" data-testid={`os-row-${o.number}`}>
              <td className="px-4 py-3">
                <OrderLink to={`/orders/${o.id}`} className="font-mono font-bold text-slate-900 dark:text-white flex items-center gap-1">
                  <Hash className="w-3.5 h-3.5 text-slate-400" />{o.number}
                  {o.is_late && <AlertTriangle className="w-3.5 h-3.5 text-rose-500" title="SLA vencido" />}
                </OrderLink>
              </td>
              <td className="px-4 py-3">
                <OrderLink to={`/orders/${o.id}`} className="block">
                  <p className="font-medium text-slate-900 dark:text-white text-sm">{o.customer_name}</p>
                  {o.customer_phone && <p className="text-xs text-slate-500 flex items-center gap-1"><Phone className="w-3 h-3" />{o.customer_phone}</p>}
                </OrderLink>
              </td>
              <td className="px-4 py-3"><OrderLink to={`/orders/${o.id}`} className="text-sm text-slate-900 dark:text-white hover:text-emerald-600 line-clamp-1">{o.title}</OrderLink></td>
              <td className="px-4 py-3 text-xs text-slate-600"><p className="font-medium">{o.queue_name || "—"}</p><p className="text-slate-400">{o.os_type_name || ""}</p></td>
              <td className="px-4 py-3 text-sm text-slate-600">{o.assigned_name || <span className="text-slate-400 italic">Não atribuída</span>}</td>
              <td className="px-4 py-3"><Badge variant="outline" className={`${PRIORITY_STYLES[o.priority]} text-[11px]`}>{o.priority}</Badge></td>
              <td className="px-4 py-3"><Badge variant="outline" className="font-medium" style={styleOf(o.status)} data-testid={`status-badge-${o.number}`}>{o.status}</Badge></td>
              <td className="px-4 py-3">
                <span className="inline-flex items-center gap-1 text-xs text-slate-600">
                  {o.channel === "manual" ? <User className="w-3.5 h-3.5" /> : <MessageCircle className="w-3.5 h-3.5 text-emerald-500" />}{o.channel}
                </span>
              </td>
              <td className="px-4 py-3 text-right text-xs text-slate-500">{new Date(o.created_at).toLocaleString("pt-BR")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
